/**
 * Lista de roles admin, compartida entre las pantallas del módulo Microservicio
 * que restringen edición por ROL (no por `SubsidiaryContextService.canSelect`,
 * que mezcla "puede elegir sucursal" con "es admin" y hoy es el único criterio
 * que usa Calibración).
 *
 * Mismo conjunto que valida el back en
 * `RoleAuthorizationService::ADMIN_ROLES` (fabricaciones.scm.api).
 */
export const ADMIN_ROLES: readonly string[] = [
    'superadmin',
    'admin',
    'fab_admin',
    'admin_retail_user',
];

export function isAdminRole(role: string | null | undefined): boolean {
    return !!role && ADMIN_ROLES.includes(role);
}
